import React, { useState, useEffect } from "react";
import {
  Button,
  AppBar,
  Toolbar,
  Typography,
  Select,
  MenuItem,
  useMediaQuery,
  Box,
  Tooltip,
  IconButton,
  Avatar,
} from "@mui/material";
// import {
//   AccountCircle,
//   CalendarToday as CalendarTodayIcon,
//   Menu as MenuIcon,
// } from '@mui/icons-material';
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateTL } from "../redux/slices/userSlice";
import TinkerLabListAPIs from "utilities/api/TinkerLabListAPIs";
import ImageBaseURL from "utilities/api/axios";
import Sidebar from "./sidebar"; // Import the Sidebar component
import CalendarIcon from "./icons/CalendarIcon";
import MessagesIcon from "./icons/MessagesIcon";
import DropdownArrow from "./icons/DropdownArrow";
import ReportIssue from "./ReportIssue/ReportIssue";

const Header = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [tlList, setTlList] = useState([]);
  const [openSidebar, setOpenSidebar] = useState(false); // State to manage Sidebar open state
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [openCreateTL, setOpenCreateTL] = useState(false);
  const navigate = useNavigate();
  // Adjust size based on screen size
  const size = isSmallScreen ? "28px" : "36px";

  const circularStyle = {
    borderRadius: "50%",
    width: size,
    height: size,
    minWidth: size,
    padding: 0,
    margin: "0 4px",
  };

  const handleTLChange = (event) => {
    dispatch(updateTL({ TL: event.target.value }));
  };

  const handleCreateTLOpen = () => {
    setOpenCreateTL(true);
  };

  const handleNavigation = (route) => {
    navigate(`/${route}`); // Replace '/calendar' with your desired path
  };

  useEffect(() => {
    const fetchTLList = async () => {
      try {
        const data = await TinkerLabListAPIs.TinkerLabsListGet();
        const sortedList = data.sort((a, b) => a.id - b.id);
        setTlList(sortedList);
      } catch (error) {
        console.error("Error fetching TL data:", error);
      }
    };

    if (user.is_admin) {
      fetchTLList();
    }
  }, [user]);

  const userAvatarUrl = user.profile_pic
    ? `${ImageBaseURL.defaults.baseURL}${user.profile_pic}`
    : "";

  const showProfileIcon =
    (user.is_admin && user.TL_name === "MBF Admin") || !user.is_admin;

  return (
    <>
      <AppBar
        sx={{
          boxShadow: "0px 4px 12px 0px #0000001A",
        }}
        position="static"
        color="inherit"
        elevation={1}
      >
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              color: "#007BFF",
            }}
          >
            {user?.is_admin ? (
              <Select
                IconComponent={DropdownArrow}
                sx={{
                  // backgroundColor: 'red',
                  color: "#007BFF",
                  fontSize: "x-large",
                  // fontWeight: 'bold',
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                value={user.TL_name || ""}
                onChange={handleTLChange}
                displayEmpty
                inputProps={{ "aria-label": "Select TL" }}
              >
                {tlList.map((lab) => (
                  <MenuItem key={lab.id} value={lab.name}>
                    {lab.name}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              user?.TL_name || ""
            )}
          </Typography>

          {user?.TL_name === "Org-Admin" && (
            <Button
              variant="contained"
              onClick={handleCreateTLOpen}
              sx={{
                marginRight: "27px",
                backgroundColor: "#007BFF",
                borderRadius: "12px",
              }}
            >
              Create TL
            </Button>
          )}

          {/* <Tooltip title="Notifications">
            <IconButton color="inherit" sx={{ marginRight: '10px' }} onClick={() => {
              setOpenNotifications(!openNotifications)
              if (notifi && !openNotifications) {
                setNotifi(false)
              }
            }
            } >
              <AlertNotificationIcon notifi={notifi} />
            </IconButton>
          </Tooltip> */}

          {/* {user.TL_name !== "Org-Admin" && ( */}
          <Tooltip title="Calendar">
            <IconButton
              color="inherit"
              sx={{ marginRight: "10px" }}
              onClick={() => handleNavigation("calendar")}
            >
              <CalendarIcon />
            </IconButton>
          </Tooltip>

          <ReportIssue displayMode="header" />
          {/* )} */}

          {/* <Tooltip title="Messages">
            <IconButton
              color="inherit"
              sx={{ marginRight: "10px" }}
              onClick={() => handleNavigation("messages")}
            >
              <MessagesIcon />
            </IconButton>
          </Tooltip> */}

          {/* Conditional rendering of profile icon */}
          {showProfileIcon && (
            <IconButton
              color="inherit"
              sx={{ marginRight: "10px" }}
              onClick={() => handleNavigation("profile")}
            >
              <Avatar alt="User Avatar" src={userAvatarUrl} />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
